import { type RouteRecordRaw } from 'vue-router'

export const inboxRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/InboxView.vue'),
    meta: {
      authZ: ({ user }) => user.hasRole('pb:super'),
      title: 'inbox',
    },
    name: 'brand.inbox',
    path: 'inbox',
  },
]
